const initialState = {
  blogs: [
    {
      key: 1,
      title: "My first sale!",
      body:
        "October 21st 2019: Today marks a very special day it is the day that i got to see star wars for the first time. This movie was super crazy and really good. It is one of the best movies of all time in my book. I cannot believe it was made so long ago and still the special effects and everything hold up to our time. I hope you enjoyed this first blog.",
      postedDate: "40/34/2023",
      picture:
        "https://external-content.duckduckgo.com/iu/?u=http%3A%2F%2Fclipart-library.com%2Fimg1%2F1194107.jpg&f=1&nofb=1",
      author: "Jenee"
    },
    {
      key: 2,
      title: "Surving the Competiton",
      body: "This is a blog post2!"
    },
    {
      key: 3,
      title: "Friends in strange places Adventure abroad",
      body: "This is a blog post3!"
    }
  ]
};

export default function BlogReducer(state = initialState, action) {
  switch (action.type) {
    default:
      return state;
  }
}
